import "@mantine/core/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { DehubThemeProvider, DEFAULT_THEME, MantineColorsTuple, MantineThemeOverride } from "@dehub/theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./styles/base.css";
import "./styles/notifications.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// de-dehub-admin is the platform back-office: it must NOT pick up the resolved
// tenant's brand color (e.g. ZAX red). Lock the Mantine "brand" palette to the
// fixed DeHub indigo so cards / ThemeIcons / buttons stay neutral for every
// tenant. Logo / name / locale still follow the tenant (handled elsewhere).
const lockedBrand: MantineThemeOverride = {
  primaryColor: "brand",
  colors: {
    brand: DEFAULT_THEME.theme.tokens.colors.primary as unknown as MantineColorsTuple,
  },
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <DehubThemeProvider themeOverride={lockedBrand}>
            <Notifications position="top-right" />
            <ModalsProvider>
              <App />
            </ModalsProvider>
          </DehubThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
